module.exports = __webpack_public_path__ + "static/media/boxheader_logo.1d4672c2.svg";